import Search from 'components/common/Search/Search';
import { useIsBrandPortalRoute } from 'hooks/useIsBrandPortalRoute';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ProductType } from 'types/Products';
import { Spinner } from 'components/common/Spinner/Spinner';

//this wrapper is to redirect  brand portals to the appropriate route early  before doing our search page calculations and triggering locks
const SearchWrapper = ({ target }: { target: ProductType }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const postSignupRedirect = urlParams.get('postSignupRedirect');
  const { signinRedirect, isAuthenticated } = useAuth();
  const brandPortalKey = useIsBrandPortalRoute();

  useEffect(() => {
    if (postSignupRedirect === 'true' && !isAuthenticated) {
      signinRedirect({
        redirect_uri: window.location.origin + window.location.pathname
      });
    }
  }, [postSignupRedirect, isAuthenticated, signinRedirect]);

  if (!isAuthenticated && postSignupRedirect === 'true') {
    return <Spinner />;
  }

  if (brandPortalKey && target === ProductType.INGREDIENTS) {
    //assuming a user has just one brand portal event, we need to rethink this in the future
    return <Navigate to={`/search/ingredients/${brandPortalKey}`} />;
  }

  return <Search target={target} />;
};

export default SearchWrapper;
